import _ from "lodash";
import moment from "moment";

import {
  SET_STUDY_PROPERTIES,
  SET_STUDY_PROPERTY_OPTIONS,
  UNSET_STUDY_PROPERTY_OPTIONS,
  CREATE_STUDY_PROPERTY,
  DELETE_STUDY_PROPERTY,
  UNSET_STUDY_PROPERTY_ACTION,
  UPDATE_STUDY_PROPERTY,
  ERROR_STUDY_PROPERTY,
  UNSET_ERROR_STUDY_PROPERTY
} from "actions/types";

const INITIAL_STATE = {
  lastAction: null,
  propertiesAvailable: {},
  propertyOptions: [],
  propertyErrors: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_STUDY_PROPERTIES:
      return {
        ...state,
        lastAction: "fetch",
        propertiesAvailable: _.mapKeys(action.payload, "id")
      };
    case SET_STUDY_PROPERTY_OPTIONS:
      return { ...state, propertyOptions: action.payload };
    case UNSET_STUDY_PROPERTY_OPTIONS:
      if (state.propertyOptions) {
        return { ...state, propertyOptions: [] };
      }
      return state;
    case UNSET_STUDY_PROPERTY_ACTION:
      return { ...state, lastAction: null };
    case CREATE_STUDY_PROPERTY:
      const createdItem = action.payload.created_items[0];
      const { id } = createdItem;
      const newState = {
        ...state,
        lastAction: "create",
        propertiesAvailable: {
          ...state.propertiesAvailable,
          [id]: createdItem
        }
      };
      return newState;
    case UPDATE_STUDY_PROPERTY:
      const updatedItem = (state.propertiesAvailable[
        action.currentStudyProperty.id
      ] = action.currentStudyProperty);
      updatedItem.updated_at = moment.utc().format("YYYY-MM-DD HH:mm:ss");
      return {
        ...state,
        lastAction: "edit",
        updatedItem
      };
    case ERROR_STUDY_PROPERTY:
      return {
        ...state,
        propertyErrors: action.payload,
        lastAction: "error"
      };
    case UNSET_ERROR_STUDY_PROPERTY:
      return {
        ...state,
        propertyErrors: {}
      };
    case DELETE_STUDY_PROPERTY:
      const updated = state.propertiesAvailable;
      _.unset(updated, `${action.currentStudyProperty.id}`);
      return { ...state, lastAction: "delete", propertiesAvailable: updated };
    default:
      return state;
  }
};
